import {useCurrentUser, useData} from "state/hooks";

export function useUserProfile() {
    const userId = useCurrentUser();
    const {app_access_profile: id} = useData({type: 'db.users', id: userId});
    return useData({type: 'db.user-profiles', id});
}